(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koppa-image-ribbon"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let frame;
    let nearby = false;
    const visibleBackground = (element) => {
      for (let node = element; node; node = node.parentElement) {
        const color = getComputedStyle(node).backgroundColor;
        if (color !== 'transparent' && color !== 'rgba(0, 0, 0, 0)') return color;
      }
      return 'transparent';
    };
    const matchPageBackground = () => {
      frame = null;
      const main = document.getElementById('MainContent');
      const ribbons = document.querySelectorAll('.kg-ribbon');
      if (!main || !ribbons.length || !nearby) return;
      const bounds = main.getBoundingClientRect();
      const x = bounds.left + bounds.width / 2;
      const y = bounds.bottom - 1;
      let surface = main;
      const pending = Array.from(main.children).reverse();
      while (pending.length) {
        const element = pending.pop();
        const rect = element.getBoundingClientRect();
        if (!rect.width || !rect.height || x < rect.left || x >= rect.right || y < rect.top || y >= rect.bottom) continue;
        const style = getComputedStyle(element);
        if (style.position === 'fixed' || style.visibility !== 'visible') continue;
        surface = element;
        pending.push(...Array.from(element.children).reverse());
      }
      const color = visibleBackground(surface);
      for (const ribbon of ribbons) ribbon.style.setProperty('--kg-page-background', color);
    };
    const schedule = () => {
      if (nearby && frame == null) frame = requestAnimationFrame(matchPageBackground);
    };
    const start = () => {
      const main = document.getElementById('MainContent');
      if (!main) return;
      const visibility = new IntersectionObserver(entries => {
        nearby = entries.some(entry => entry.isIntersecting);
        if (nearby) schedule();
      }, { rootMargin: '300px' });
      document.querySelectorAll('.kg-ribbon').forEach(ribbon => visibility.observe(ribbon));
      new ResizeObserver(schedule).observe(main);
      new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
    window.addEventListener('load', schedule, { once: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:reorder', schedule);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koppa-thank-you"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('[data-koppa-thanks]').forEach((root) => {
        if (root.dataset.ready) return;
        root.dataset.ready = 'true';
        const track = (name) => {
          const privacy = window.Shopify && window.Shopify.customerPrivacy;
          if (!privacy || typeof privacy.currentVisitorConsent !== 'function' || privacy.currentVisitorConsent().analytics !== 'yes' || !privacy.analyticsProcessingAllowed() || typeof window.CupraTrack !== 'function') return;
          window.CupraTrack(name, { source: 'thank_you_card', page_type: 'post_purchase' });
        };
        track('Thank You Page Viewed');
        const copy = root.querySelector('[data-copy-code]');
        const copyStatus = root.querySelector('[data-copy-status]');
        if (copy) {
          copy.hidden = false;
          copy.addEventListener('click', async () => {
            try {
              await navigator.clipboard.writeText(root.querySelector('[data-discount-code]').textContent.trim());
              copy.textContent = copy.dataset.copied;
              copyStatus.textContent = copy.dataset.copied;
              track('Thank You Code Copied');
            } catch (_) { copyStatus.textContent = copy.dataset.fallback; }
          });
        }
        const question = root.querySelector('[data-rating-question]');
        root.querySelectorAll('[data-stage]').forEach((input) => input.addEventListener('change', () => {
          question.textContent = input.dataset.stage === 'not_yet' ? question.dataset.delivery : question.dataset.general;
        }));
        root.querySelector('[data-shop-discount]').addEventListener('click', () => track('Thank You Shop Clicked'));
        const success = root.querySelector('[data-feedback-success]');
        const error = root.querySelector('[data-feedback-error]');
        if (success) { success.focus({ preventScroll: true }); track('Thank You Feedback Submitted'); }
        if (error) error.focus();
        const form = root.querySelector('form');
        const submit = root.querySelector('[data-submit-feedback]');
        if (form && submit) {
          const label = submit.innerHTML;
          let reset;
          const restore = () => { clearTimeout(reset); submit.disabled = false; submit.innerHTML = label; };
          form.addEventListener('submit', () => {
            if (!form.checkValidity()) return;
            submit.disabled = true;
            submit.textContent = submit.dataset.sending;
            reset = setTimeout(restore, 12000);
          });
          window.addEventListener('pageshow', restore);
        }
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-about"] && !Shopify.designMode) return;
  try {
    
(() => {
  const controllers = new Map();
  function initialize(scope) {
    scope.querySelectorAll('.about-page').forEach(root => {
      if (controllers.has(root)) return;
      const abort = new AbortController();
      const options = { signal: abort.signal };
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const observers = [];
      const animations = new Set();
      const films = [];
      const reveal = entries => {
        let order = 0;
        entries.filter(entry => entry.isIntersecting).forEach(entry => {
          const item = entry.target;
          beliefObserver.unobserve(item);
          if (reduced.matches || !item.animate) return;
          const animation = item.animate([
            { opacity: 0, transform: 'perspective(900px) translateY(20px) rotateX(4deg)' },
            { opacity: 1, transform: 'perspective(900px) translateY(0) rotateX(0)' }
          ], { duration: 650, delay: order++ * 140, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'backwards' });
          animations.add(animation);
          animation.finished.then(() => animations.delete(animation), () => animations.delete(animation));
        });
      };
      const beliefObserver = 'IntersectionObserver' in window ? new IntersectionObserver(reveal, { threshold: .15 }) : null;
      if (beliefObserver) {
        root.querySelectorAll('[data-about-belief]').forEach(item => beliefObserver.observe(item));
        observers.push(beliefObserver);
      }
      reduced.addEventListener('change', () => {
        if (reduced.matches) animations.forEach(animation => animation.cancel());
      }, options);
      const dialog = root.querySelector('.ab-science');
      let opener;
      let previousOverflow;
      if (dialog && typeof dialog.showModal === 'function') {
        root.querySelectorAll('[data-about-science-open]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click', () => {
            opener = button;
            previousOverflow = document.documentElement.style.overflow;
            dialog.showModal();
            document.documentElement.style.overflow = 'hidden';
            films.forEach(film => film.sync());
          }, options);
        });
        const close = () => dialog.close();
        dialog.querySelector('[data-about-science-close]').addEventListener('click', close, options);
        dialog.addEventListener('click', event => {
          const rect = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
        }, options);
        dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = previousOverflow;
          opener?.focus({ preventScroll: true });
          films.forEach(film => film.sync());
        }, options);
      }
      root.querySelectorAll('[data-about-film]').forEach(panel => {
        const video = panel.querySelector('.ab-molecule-video');
        const button = panel.querySelector('.ab-molecule__motion');
        if (!video || !button) return;
        let inView = false;
        let userPaused = false;
        let userPlayed = false;
        const label = () => { button.textContent = video.paused ? button.dataset.play : button.dataset.pause; };
        const sync = () => {
          if (!inView || document.hidden || dialog?.open || userPaused || (reduced.matches && !userPlayed)) {
            video.pause();
          } else {
            video.muted = true;
            video.play()?.catch(label);
          }
          label();
        };
        video.muted = true;
        video.playsInline = true;
        video.loop = true;
        button.addEventListener('click', () => {
          userPaused = !video.paused;
          userPlayed = !userPaused;
          sync();
        }, options);
        video.addEventListener('play', label, options);
        video.addEventListener('pause', label, options);
        video.addEventListener('canplay', sync, options);
        document.addEventListener('visibilitychange', sync, options);
        window.addEventListener('pageshow', sync, options);
        reduced.addEventListener('change', () => { userPlayed = false; sync(); }, options);
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(entries => {
            inView = entries.some(entry => entry.isIntersecting);
            sync();
          }, { threshold: .05 });
          observer.observe(panel);
          observers.push(observer);
        } else { inView = panel.getClientRects().length > 0; sync(); }
        films.push({ video, sync });
        label();
      });
      controllers.set(root, () => {
        if (dialog?.open) { dialog.close(); document.documentElement.style.overflow = previousOverflow; }
        abort.abort();
        observers.forEach(observer => observer.disconnect());
        animations.forEach(animation => animation.cancel());
        films.forEach(film => film.video.pause());
        controllers.delete(root);
      });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, destroy] of controllers) if (event.target.contains(root)) destroy();
  });
})();


  } catch(e) { console.error(e); }
})();
})();
